import axios from 'axios'

export const httpAxios = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Methods': "GET, POST, OPTIONS",
        //'Access-Control-Allow-Headers': "Origin, Content-Type, X-Auth-Token"
    }
});